import apiRequestService from '@/commonProject/service/apiRequestService';

export default class LoginRepository {
    /**
     * メンテナンス状態取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getMaintenanceModeApi(API_URL, queryParam) {
        const result = await apiRequestService.requestServerGet(API_URL + '/mtn', queryParam, null);
        return result;
    }

    /**
     * ベンダー情報取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getVendorApi(API_URL, queryParam) {
        const result = await apiRequestService.requestServerGet(API_URL + '/vnd', queryParam, null);
        return result;
    }

    /**
     * 個人情報取扱規定取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getRegPvcContentApi(API_URL, queryParam) {
        const result = await apiRequestService.requestServerGet(API_URL + '/regpvc', queryParam, null);
        return result;
    }

    /**
     * ユーザー情報取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getLoginUserInfoApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/usr', queryParam, idToken);
        return result;
    }

    /**
     * ユーザー状態確認(ログイン)APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getUserStatusByLoginActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/usrstslin', queryParam, idToken);
        return result;
    }

    /**
     * ユーザーログイン完了APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async postUserLoginDateUpdateApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrlinupd', queryParam, idToken);
        return result;
    }

    /**
     * ユーザーパスワード更新完了APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async postUserLoginPasswordUpdateedDateUpdateApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrpwdupd', queryParam, idToken);
        return result;
    }
}
